/**
 * Mock page data for development and testing
 * This file contains examples of different page types including the new GridLayout
 * with responsive layout attributes for Bootstrap's grid system (12-column grid)
 */

export const mockPages = [
  {
    type: 'landing',
    page: {
      key: 'landing',
      title: 'Welcome to the Demo'
    },
    path: {
      key: 'welcome',
      title: 'Welcome'
    }
  },
  {
    type: 'survey',
    page: {
      key: 'standardPage',
      title: 'Standard Survey Page',
      type: 'Standard' // Default type
    },
    path: {
      key: 'survey',
      title: 'Survey'
    },
    questionGroups: [
      {
        key: 'standardQuestionGroup',
        type: 'Base',
        title: 'Standard Question Group',
        questions: [
          {
            appkey: 'question1',
            type: 'RadioButton',
            label: 'What is your favorite color?',
            options: [
              { label: 'Red', value: 'red' },
              { label: 'Blue', value: 'blue' },
              { label: 'Green', value: 'green' }
            ]
          }
        ]
      }
    ]
  },
  {
    type: 'survey',
    page: {
      key: 'gridLayoutPage',
      title: 'Grid Layout Example',
      type: 'GridLayout' // Using our new GridLayout type
    },
    path: {
      key: 'survey',
      title: 'Survey'
    },
    questionGroups: [
      {
        key: 'headerWidget',
        type: 'TextWidget',
        attributes: {
          width: 24,       // Full width (24 columns out of 24)
          height: 1,       // Single row height
          // Responsive attributes for Ant Design grid
          xs: 24,          // Full width on extra small devices (phones)
          sm: 24,          // Full width on small devices (tablets)
          md: 24,          // Full width on medium devices
          lg: 24,          // Full width on large devices
          xl: 24,          // Full width on extra large devices
          options: {
            title: 'Welcome to the Grid Layout',
            subtitle: 'This page demonstrates the new layout system',
            content: 'Below you will find different widgets arranged in a grid.',
            backgroundColor: '#f5f5f5'
          }
        }
      },
      {
        key: 'questionWidget',
        type: 'Questions',
        attributes: {
          width: 12,       // Half width (12 columns out of 24)
          height: 3,
          // Responsive attributes - different sizes at different breakpoints
          xs: 24,          // Full width on phones
          sm: 24,          // Full width on tablets
          md: 12,          // Half width on medium devices
          lg: 12,          // Half width on large devices
          xl: 8,           // One-third width on extra large devices
          options: {
            title: 'Answer these questions',
            description: 'Your feedback is important to us'
          }
        },
        questions: [
          {
            appkey: 'satisfaction',
            type: 'RadioButton',
            label: 'How satisfied are you with our service?',
            options: [
              { label: 'Very Satisfied', value: 'very' },
              { label: 'Satisfied', value: 'satisfied' },
              { label: 'Neutral', value: 'neutral' },
              { label: 'Dissatisfied', value: 'dissatisfied' },
              { label: 'Very Dissatisfied', value: 'very_dissatisfied' }
            ]
          },
          {
            appkey: 'improvement',
            type: 'TextArea',
            label: 'How can we improve our service?'
          }
        ]
      },
      {
        key: 'chartWidget',
        type: 'ChartWidget',
        attributes: {
          width: 12,       // Half width (12 columns out of 24)
          height: 3,
          // Responsive grid settings
          xs: 24,          // Full width on phones
          sm: 24,          // Full width on tablets
          md: 12,          // Half width on medium devices
          lg: 12,          // Half width on large devices
          xl: 10,          // 5/12 width on extra large devices
          options: {
            title: 'Results Visualization',
            chartType: 'bar',
            dataSource: 'answers.satisfaction',
            labels: ['Very Satisfied', 'Satisfied', 'Neutral', 'Dissatisfied', 'Very Dissatisfied']
          }
        }
      },
      {
        key: 'infoWidget',
        type: 'TextWidget',
        attributes: {
          width: 8,        // One-third width (8 columns out of 24)
          height: 2,
          // Responsive behavior
          xs: 24,          // Full width on phones
          sm: 12,          // Half width on tablets
          md: 8,           // 1/3 width on medium devices
          lg: 6,           // 1/4 width on large devices
          xl: 6,           // 1/4 width on extra large devices
          options: {
            title: 'Responsive Demo',
            content: 'This widget changes its width based on the screen size. Try resizing your browser to see how it adapts.',
            backgroundColor: '#fff1f0'
          }
        }
      },
      {
        key: 'footerWidget',
        type: 'TextWidget',
        attributes: {
          width: 24,       // Full width (24 columns out of 24)
          height: 1,
          // Responsive grid settings (same for all breakpoints - always full width)
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          options: {
            content: 'Thank you for taking the time to provide your feedback.',
            backgroundColor: '#e6f7ff'
          }
        }
      }
    ]
  },
  {
    type: 'summary',
    page: {
      key: 'summary',
      title: 'Summary'
    },
    path: {
      key: 'summary',
      title: 'Summary'
    }
  }
];